function createAccordionItem(questionText: string, answerContent: Node[]): HTMLDivElement {
    const template = document.querySelector('[data-rek-ai-faq-template]') as HTMLTemplateElement | null;
    if (!template) {
        throw new Error('Rek AI FAQ template was not found.');
    }

    const fragment = template.content.cloneNode(true) as DocumentFragment;
    const item = fragment.querySelector('.accordion-block') as HTMLDivElement | null;
    const title = fragment.querySelector('.accordion-block__title-text') as HTMLHeadingElement | null;
    const text = fragment.querySelector('.accordion-block__text') as HTMLDivElement | null;

    if (!item || !title || !text) {
        throw new Error('Rek AI FAQ template is missing required elements.');
    }

    title.textContent = questionText;
    answerContent.forEach(node => text.appendChild(node));

    return item;
}

function transformRekAiFaq(rekPrediction: HTMLElement) {
    if (rekPrediction.dataset.rekFaqStyled === '1') {
        return;
    }

    const list = rekPrediction.querySelector('.rekai-accordion__list') as HTMLDListElement | null;
    if (!list) {
        return;
    }

    const nodes = Array.from(list.children);
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < nodes.length; index += 2) {
        const header = nodes[index] as HTMLElement | undefined;
        const body = nodes[index + 1] as HTMLElement | undefined;

        if (!header?.matches('dt') || !body?.matches('dd')) {
            continue;
        }

        const question = header.querySelector('.rekai-accordion__question-text')?.textContent?.trim();
        if (!question) {
            continue;
        }

        fragment.appendChild(createAccordionItem(question, Array.from(body.childNodes)));
    }

    list.remove();
    rekPrediction.appendChild(fragment);
    rekPrediction.dataset.rekFaqStyled = '1';
}

function scanRekAiFaq(root: ParentNode = document) {
    root.querySelectorAll('.rek-prediction[data-entitytype="rekai-qna"]').forEach(element => {
        transformRekAiFaq(element as HTMLElement);
    });
}

scanRekAiFaq();

const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) {
                return;
            }

            if (node.matches('.rek-prediction[data-entitytype="rekai-qna"]')) {
                transformRekAiFaq(node);
            }

            if (node.matches('.rekai-accordion__list')) {
                const rekPrediction = node.closest('.rek-prediction[data-entitytype="rekai-qna"]');
                if (rekPrediction instanceof HTMLElement) {
                    transformRekAiFaq(rekPrediction);
                }
            }

            scanRekAiFaq(node);
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
